import { Modal } from 'bootstrap'
import moment from 'moment'
import { datepicker } from 'flatpickr-prefabs'
import { ddlGenericInitialise } from 'slim-select-prefabs'

const initialise = () => {
	new JSTable('#ExpensesTable', {
		columns: [
			{ select: 0, sort: 'desc' },
			{ select: 5, sortable: false },
			{
				select: 2,
				render(cell: HTMLTableCellElement) {
					const data = cell.innerHTML
					return moment(data).format('DD/MM/YYYY')
				}
			}
		],
		labels: {
			loading: 'Loading...',
			noRows: 'No data available in table'
		},
		perPage: 50
	})
	const btnAddNewExpenses = document.querySelector('.btnAddNewExpenses') as HTMLFormElement
	if (btnAddNewExpenses != null) {
		btnAddNewExpenses.addEventListener('click', () => {
			const newExpensesDiv = document.querySelector(
				'.NewExpenses'
			) as HTMLFormElement
			const newExpenses = new Modal(newExpensesDiv, {
				backdrop: true,
				keyboard: true
			})
			newExpenses.show()
		})
	}
	const chkNewExpenseClaimed = document.getElementById('chkNewExpenseClaimed') as HTMLInputElement
	if (chkNewExpenseClaimed != null) {
		chkNewExpenseClaimed.addEventListener('change', () => {
			if (chkNewExpenseClaimed.checked) {
				chkNewExpenseClaimed.setAttribute('value', 'true')
			} else {
				chkNewExpenseClaimed.setAttribute('value', 'false')
			}
		})
	}
	datepicker()
	ddlGenericInitialise()
}
window.addEventListener('load', () => {
	initialise()
})
